import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

// Suppress default Leaflet icon path warnings
delete L.Icon.Default.prototype._getIconUrl;

/** Uniform red dot — same size for every marker on the map */
const dotIcon = new L.DivIcon({
  html: `<div style="
    width:10px;height:10px;
    background:#DC2A1C;
    border-radius:50%;
    border:2px solid rgba(255,255,255,0.9);
    box-shadow:0 0 5px rgba(220,42,28,0.65);
  "></div>`,
  className: "",
  iconSize: [10, 10],
  iconAnchor: [5, 5],
  popupAnchor: [0, -8],
});

/** India — company-owned offices */
const OFFICES = [
  { city: "Mumbai",    label: "Head Office",   lat: 19.1196, lng: 72.8794, address: "B 103-105, Sagar Tech Plaza, Andheri (E), Mumbai 400072", phone: "+91 22 4252 7200", isHead: true },
  { city: "Ahmedabad", label: "Branch Office", lat: 23.0225, lng: 72.5714, address: "Ahmedabad, Gujarat",            isHead: false },
  { city: "Hyderabad", label: "Branch Office", lat: 17.3850, lng: 78.4867, address: "Hyderabad, Telangana",          isHead: false },
  { city: "Kolkata",   label: "Branch Office", lat: 22.5726, lng: 88.3639, address: "Kolkata / Haldia, West Bengal", isHead: false },
  { city: "Bangalore", label: "Branch Office", lat: 12.9716, lng: 77.5946, address: "Bangalore, Karnataka",         isHead: false },
  { city: "Chennai",   label: "Branch Office", lat: 13.0827, lng: 80.2707, address: "Chennai, Tamil Nadu",          isHead: false },
  { city: "Delhi",     label: "Branch Office", lat: 28.6139, lng: 77.2090, address: "Delhi, India",                 isHead: false },
];

/** Global network — partner hubs across 180+ countries */
const GLOBAL_HUBS = [
  // Middle East
  { city: "Dubai",          country: "UAE",             lat: 25.2048,  lng: 55.2708   },
  { city: "Abu Dhabi",      country: "UAE",             lat: 24.4539,  lng: 54.3773   },
  { city: "Doha",           country: "Qatar",           lat: 25.2854,  lng: 51.5310   },
  { city: "Riyadh",         country: "Saudi Arabia",    lat: 24.7136,  lng: 46.6753   },
  { city: "Jeddah",         country: "Saudi Arabia",    lat: 21.4858,  lng: 39.1925   },
  { city: "Kuwait City",    country: "Kuwait",          lat: 29.3759,  lng: 47.9774   },
  { city: "Muscat",         country: "Oman",            lat: 23.5880,  lng: 58.3829   },
  { city: "Manama",         country: "Bahrain",         lat: 26.2235,  lng: 50.5876   },
  { city: "Beirut",         country: "Lebanon",         lat: 33.8938,  lng: 35.5018   },
  { city: "Amman",          country: "Jordan",          lat: 31.9454,  lng: 35.9284   },
  { city: "Baghdad",        country: "Iraq",            lat: 33.3152,  lng: 44.3661   },
  { city: "Tehran",         country: "Iran",            lat: 35.6892,  lng: 51.3890   },
  // Africa
  { city: "Nairobi",        country: "Kenya",           lat: -1.2921,  lng: 36.8219   },
  { city: "Mombasa",        country: "Kenya",           lat: -4.0435,  lng: 39.6682   },
  { city: "Johannesburg",   country: "South Africa",    lat: -26.2041, lng: 28.0473   },
  { city: "Cape Town",      country: "South Africa",    lat: -33.9249, lng: 18.4241   },
  { city: "Durban",         country: "South Africa",    lat: -29.8587, lng: 31.0218   },
  { city: "Lagos",          country: "Nigeria",         lat:  6.5244,  lng:  3.3792   },
  { city: "Abuja",          country: "Nigeria",         lat:  9.0765,  lng:  7.3986   },
  { city: "Cairo",          country: "Egypt",           lat: 30.0444,  lng: 31.2357   },
  { city: "Alexandria",     country: "Egypt",           lat: 31.2001,  lng: 29.9187   },
  { city: "Casablanca",     country: "Morocco",         lat: 33.5731,  lng: -7.5898   },
  { city: "Tunis",          country: "Tunisia",         lat: 36.8065,  lng: 10.1815   },
  { city: "Algiers",        country: "Algeria",         lat: 36.7372,  lng:  3.0865   },
  { city: "Accra",          country: "Ghana",           lat:  5.6037,  lng: -0.1870   },
  { city: "Dakar",          country: "Senegal",         lat: 14.7167,  lng: -17.4677  },
  { city: "Addis Ababa",    country: "Ethiopia",        lat:  9.0320,  lng: 38.7469   },
  { city: "Dar es Salaam",  country: "Tanzania",        lat: -6.7924,  lng: 39.2083   },
  { city: "Kampala",        country: "Uganda",          lat:  0.3476,  lng: 32.5825   },
  { city: "Lusaka",         country: "Zambia",          lat: -15.4167, lng: 28.2833   },
  { city: "Harare",         country: "Zimbabwe",        lat: -17.8252, lng: 31.0335   },
  { city: "Maputo",         country: "Mozambique",      lat: -25.9692, lng: 32.5732   },
  { city: "Luanda",         country: "Angola",          lat: -8.8390,  lng: 13.2894   },
  { city: "Douala",         country: "Cameroon",        lat:  4.0511,  lng:  9.7679   },
  { city: "Abidjan",        country: "Ivory Coast",     lat:  5.3600,  lng: -4.0083   },
  { city: "Tripoli",        country: "Libya",           lat: 32.9011,  lng: 13.1800   },
  // Europe
  { city: "London",         country: "UK",              lat: 51.5074,  lng: -0.1278   },
  { city: "Manchester",     country: "UK",              lat: 53.4808,  lng: -2.2426   },
  { city: "Frankfurt",      country: "Germany",         lat: 50.1109,  lng:  8.6821   },
  { city: "Hamburg",        country: "Germany",         lat: 53.5753,  lng: 10.0153   },
  { city: "Munich",         country: "Germany",         lat: 48.1351,  lng: 11.5820   },
  { city: "Amsterdam",      country: "Netherlands",     lat: 52.3676,  lng:  4.9041   },
  { city: "Rotterdam",      country: "Netherlands",     lat: 51.9244,  lng:  4.4777   },
  { city: "Paris",          country: "France",          lat: 48.8566,  lng:  2.3522   },
  { city: "Lyon",           country: "France",          lat: 45.7640,  lng:  4.8357   },
  { city: "Milan",          country: "Italy",           lat: 45.4642,  lng:  9.1900   },
  { city: "Rome",           country: "Italy",           lat: 41.9028,  lng: 12.4964   },
  { city: "Genoa",          country: "Italy",           lat: 44.4056,  lng:  8.9463   },
  { city: "Istanbul",       country: "Turkey",          lat: 41.0082,  lng: 28.9784   },
  { city: "Ankara",         country: "Turkey",          lat: 39.9334,  lng: 32.8597   },
  { city: "Moscow",         country: "Russia",          lat: 55.7558,  lng: 37.6173   },
  { city: "St. Petersburg", country: "Russia",          lat: 59.9311,  lng: 30.3609   },
  { city: "Madrid",         country: "Spain",           lat: 40.4168,  lng: -3.7038   },
  { city: "Barcelona",      country: "Spain",           lat: 41.3851,  lng:  2.1734   },
  { city: "Lisbon",         country: "Portugal",        lat: 38.7223,  lng: -9.1393   },
  { city: "Brussels",       country: "Belgium",         lat: 50.8503,  lng:  4.3517   },
  { city: "Antwerp",        country: "Belgium",         lat: 51.2194,  lng:  4.4025   },
  { city: "Zurich",         country: "Switzerland",     lat: 47.3769,  lng:  8.5417   },
  { city: "Geneva",         country: "Switzerland",     lat: 46.2044,  lng:  6.1432   },
  { city: "Vienna",         country: "Austria",         lat: 48.2082,  lng: 16.3738   },
  { city: "Warsaw",         country: "Poland",          lat: 52.2297,  lng: 21.0122   },
  { city: "Prague",         country: "Czech Republic",  lat: 50.0755,  lng: 14.4378   },
  { city: "Budapest",       country: "Hungary",         lat: 47.4979,  lng: 19.0402   },
  { city: "Bucharest",      country: "Romania",         lat: 44.4268,  lng: 26.1025   },
  { city: "Athens",         country: "Greece",          lat: 37.9838,  lng: 23.7275   },
  { city: "Piraeus",        country: "Greece",          lat: 37.9475,  lng: 23.6464   },
  { city: "Stockholm",      country: "Sweden",          lat: 59.3293,  lng: 18.0686   },
  { city: "Oslo",           country: "Norway",          lat: 59.9139,  lng: 10.7522   },
  { city: "Copenhagen",     country: "Denmark",         lat: 55.6761,  lng: 12.5683   },
  { city: "Helsinki",       country: "Finland",         lat: 60.1699,  lng: 24.9384   },
  { city: "Riga",           country: "Latvia",          lat: 56.9496,  lng: 24.1052   },
  { city: "Kiev",           country: "Ukraine",         lat: 50.4501,  lng: 30.5234   },
  { city: "Sofia",          country: "Bulgaria",        lat: 42.6977,  lng: 23.3219   },
  // Americas
  { city: "New York",       country: "USA",             lat: 40.7128,  lng: -74.0060  },
  { city: "Los Angeles",    country: "USA",             lat: 34.0522,  lng: -118.2437 },
  { city: "Chicago",        country: "USA",             lat: 41.8781,  lng: -87.6298  },
  { city: "Miami",          country: "USA",             lat: 25.7617,  lng: -80.1918  },
  { city: "Houston",        country: "USA",             lat: 29.7604,  lng: -95.3698  },
  { city: "Dallas",         country: "USA",             lat: 32.7767,  lng: -96.7970  },
  { city: "Atlanta",        country: "USA",             lat: 33.7490,  lng: -84.3880  },
  { city: "Seattle",        country: "USA",             lat: 47.6062,  lng: -122.3321 },
  { city: "San Francisco",  country: "USA",             lat: 37.7749,  lng: -122.4194 },
  { city: "Boston",         country: "USA",             lat: 42.3601,  lng: -71.0589  },
  { city: "Toronto",        country: "Canada",          lat: 43.6510,  lng: -79.3470  },
  { city: "Vancouver",      country: "Canada",          lat: 49.2827,  lng: -123.1207 },
  { city: "Montreal",       country: "Canada",          lat: 45.5017,  lng: -73.5673  },
  { city: "São Paulo",      country: "Brazil",          lat: -23.5505, lng: -46.6333  },
  { city: "Rio de Janeiro", country: "Brazil",          lat: -22.9068, lng: -43.1729  },
  { city: "Buenos Aires",   country: "Argentina",       lat: -34.6037, lng: -58.3816  },
  { city: "Santiago",       country: "Chile",           lat: -33.4489, lng: -70.6693  },
  { city: "Lima",           country: "Peru",            lat: -12.0464, lng: -77.0428  },
  { city: "Bogotá",         country: "Colombia",        lat:  4.7110,  lng: -74.0721  },
  { city: "Mexico City",    country: "Mexico",          lat: 19.4326,  lng: -99.1332  },
  { city: "Guadalajara",    country: "Mexico",          lat: 20.6597,  lng: -103.3496 },
  { city: "Panama City",    country: "Panama",          lat:  8.9936,  lng: -79.5197  },
  { city: "Caracas",        country: "Venezuela",       lat: 10.4806,  lng: -66.9036  },
  { city: "Quito",          country: "Ecuador",         lat: -0.1807,  lng: -78.4678  },
  // Asia Pacific
  { city: "Singapore",      country: "Singapore",       lat:  1.3521,  lng: 103.8198  },
  { city: "Hong Kong",      country: "China (HK)",      lat: 22.3193,  lng: 114.1694  },
  { city: "Shanghai",       country: "China",           lat: 31.2304,  lng: 121.4737  },
  { city: "Beijing",        country: "China",           lat: 39.9042,  lng: 116.4074  },
  { city: "Shenzhen",       country: "China",           lat: 22.5431,  lng: 114.0579  },
  { city: "Guangzhou",      country: "China",           lat: 23.1291,  lng: 113.2644  },
  { city: "Tianjin",        country: "China",           lat: 39.3434,  lng: 117.3616  },
  { city: "Chengdu",        country: "China",           lat: 30.5728,  lng: 104.0668  },
  { city: "Qingdao",        country: "China",           lat: 36.0671,  lng: 120.3826  },
  { city: "Tokyo",          country: "Japan",           lat: 35.6762,  lng: 139.6503  },
  { city: "Osaka",          country: "Japan",           lat: 34.6937,  lng: 135.5023  },
  { city: "Nagoya",         country: "Japan",           lat: 35.1815,  lng: 136.9066  },
  { city: "Seoul",          country: "South Korea",     lat: 37.5665,  lng: 126.9780  },
  { city: "Busan",          country: "South Korea",     lat: 35.1796,  lng: 129.0756  },
  { city: "Bangkok",        country: "Thailand",        lat: 13.7563,  lng: 100.5018  },
  { city: "Kuala Lumpur",   country: "Malaysia",        lat:  3.1390,  lng: 101.6869  },
  { city: "Port Klang",     country: "Malaysia",        lat:  3.0000,  lng: 101.3833  },
  { city: "Jakarta",        country: "Indonesia",       lat: -6.2088,  lng: 106.8456  },
  { city: "Surabaya",       country: "Indonesia",       lat: -7.2504,  lng: 112.7688  },
  { city: "Manila",         country: "Philippines",     lat: 14.5995,  lng: 120.9842  },
  { city: "Ho Chi Minh",    country: "Vietnam",         lat: 10.8231,  lng: 106.6297  },
  { city: "Hanoi",          country: "Vietnam",         lat: 21.0285,  lng: 105.8542  },
  { city: "Phnom Penh",     country: "Cambodia",        lat: 11.5564,  lng: 104.9282  },
  { city: "Yangon",         country: "Myanmar",         lat: 16.8409,  lng: 96.1735   },
  { city: "Sydney",         country: "Australia",       lat: -33.8688, lng: 151.2093  },
  { city: "Melbourne",      country: "Australia",       lat: -37.8136, lng: 144.9631  },
  { city: "Brisbane",       country: "Australia",       lat: -27.4698, lng: 153.0251  },
  { city: "Perth",          country: "Australia",       lat: -31.9505, lng: 115.8605  },
  { city: "Auckland",       country: "New Zealand",     lat: -36.8485, lng: 174.7633  },
  { city: "Colombo",        country: "Sri Lanka",       lat:  6.9271,  lng:  79.8612  },
  { city: "Karachi",        country: "Pakistan",        lat: 24.8607,  lng:  67.0011  },
  { city: "Lahore",         country: "Pakistan",        lat: 31.5204,  lng: 74.3587   },
  { city: "Dhaka",          country: "Bangladesh",      lat: 23.8103,  lng:  90.4125  },
  { city: "Chittagong",     country: "Bangladesh",      lat: 22.3569,  lng: 91.7832   },
  { city: "Kathmandu",      country: "Nepal",           lat: 27.7172,  lng: 85.3240   },
  { city: "Kabul",          country: "Afghanistan",     lat: 34.5553,  lng: 69.2075   },
  { city: "Tashkent",       country: "Uzbekistan",      lat: 41.2995,  lng: 69.2401   },
  { city: "Almaty",         country: "Kazakhstan",      lat: 43.2220,  lng: 76.8512   },
  { city: "Taipei",         country: "Taiwan",          lat: 25.0330,  lng: 121.5654  },
  { city: "Ulaanbaatar",    country: "Mongolia",        lat: 47.8864,  lng: 106.9057  },
];

export default function GlobalFootprintMap() {
  return (
    <MapContainer
      center={[10, 10]}
      zoom={2}
      style={{ height: 560, width: "100%" }}
      scrollWheelZoom={false}
      zoomControl={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {/* Global partner hubs */}
      {GLOBAL_HUBS.map((hub) => (
        <Marker key={`hub-${hub.city}`} position={[hub.lat, hub.lng]} icon={dotIcon}>
          <Popup>
            <div style={{ minWidth: 130 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: "#1A1A1A", marginBottom: 2 }}>{hub.city}</div>
              <div style={{ fontSize: 10, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.1em", fontWeight: 600 }}>{hub.country}</div>
              <div style={{ fontSize: 11, color: "#DC2A1C", fontWeight: 600, marginTop: 4 }}>Partner Hub</div>
            </div>
          </Popup>
        </Marker>
      ))}

      {/* India offices */}
      {OFFICES.map((office) => (
        <Marker key={`office-${office.city}`} position={[office.lat, office.lng]} icon={dotIcon}>
          <Popup>
            <div style={{ minWidth: 160 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#1A1A1A", marginBottom: 2 }}>{office.city}</div>
              <div style={{ fontSize: 10, color: office.isHead ? "#DC2A1C" : "#6b7280", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 6, fontWeight: 600 }}>{office.label}</div>
              <div style={{ fontSize: 12, color: "#374151", lineHeight: 1.5 }}>{office.address}</div>
              {office.phone && <div style={{ marginTop: 6, fontSize: 11, color: "#DC2A1C", fontWeight: 600 }}>{office.phone}</div>}
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
